import { toast } from 'react-toastify'

import api, { setAuthorizationHeader } from '../lib/api'

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE'
export const RENEW_SUCCESS = 'RENEW_SUCCESS'
export const RENEW_FAILURE = 'RENEW_FAILURE'

export const login = (username, password) => async dispatch => {
  try {
    const { data } = await api.post('/api/auth/login', { username, password })
    setAuthorizationHeader(data.token)
    startAutoRenewToken(dispatch, data.renewInterval)
    await dispatch({ type: LOGIN_SUCCESS, data })
  } catch (err) {
    toast.error('Failed to login.')
    console.log(err.msg)
    dispatch({ type: LOGIN_FAILURE, err })
  }
}

export const logout = () => async dispatch => {
  try {
    await api.get('/api/auth/logout')
    stopAutoRenewToken()
    await dispatch({ type: LOGOUT_SUCCESS })
  } catch (err) {
    toast.error('Failed to out.')
    console.log(err.msg)
    dispatch({ type: LOGOUT_FAILURE, err })
  }
}

export const renew = () => async dispatch => {
  try {
    const { data } = await api.get('/api/auth/renew')
    setAuthorizationHeader(data.token)
    await dispatch({ type: RENEW_SUCCESS, data })
  } catch (err) {
    toast.error('Login session expired.')
    console.log(err.msg)
    dispatch({ type: RENEW_FAILURE, err })
  }
}

let interval

function startAutoRenewToken (dispatch, renewInterval) {
  stopAutoRenewToken()
  interval = setInterval(() => {
    dispatch(renew())
  }, renewInterval)
}

function stopAutoRenewToken () {
  if (interval) {
    clearInterval(interval)
    interval = undefined
  }
}


// WEBPACK FOOTER //
// ./src/actions/auth.js